<div>
  @switch (dialogStep()) {
    @case (1) {
      <div class="modal-header">
        <h4 class="modal-title">1. Override all locations</h4>
        <div class="dots">
          <span class="dot active"></span>
          <span class="dot"></span>
        </div>
      </div>
      <div class="form-group modal-body">
        <app-singleselectbox decorator name="overrideLocation" caption="Select an existing global location"
          [(value)]="overrideId" [dataSource]="globalLocations()" valueExpr="Id" displayExpr="Name">
        </app-singleselectbox>
        @if (distributionCount() >= 0) {
          <p class="mt-2">
            This will override <strong>outgoing locations</strong> on all <strong>{{distributionCount()}}
            distributions</strong> and send all documents to the chosen location.
          </p>
        }
        @else {
          <p class="mt-2">Loading...</p>
        }
      </div>
      <div class="modal-footer">
        <div class="button-container">
          @if (initialOverrideId() > 0) {
            <app-button tertiery class="button-item-1" width="100%" (buttonClick)="confirmStop()">Stop override</app-button>
          }
          <app-button secondary class="button-item-2" width="100%" (buttonClick)="cancel()">Cancel</app-button>
          <app-button primary class="button-item-3" width="100%" [disabled]="!canNext()" (buttonClick)="confirmOverride()">Next</app-button>
        </div>
      </div>
    }
    @case (2) {
      <div class="modal-header">
        <h4 class="modal-title">2. Override all locations</h4>
        <div class="dots">
          <span class="dot"></span>
          <span class="dot active"></span>
        </div>
      </div>
      <div class="form-group modal-body">
        @if (distributionCount() >= 0) {
          <p class="mt-2">
            This will override <strong>outgoing locations</strong> on all <strong>{{distributionCount()}}
            distributions</strong> and send all documents to <strong>{{selectedLocation()?.Name}}</strong>.
          </p>
        }
        <p class="mt-2">You can change this at any time.</p>
      </div>
      <div class="modal-footer">
        <div class="button-container">
          <app-button tertiery class="button-item-1" width="100%" (buttonClick)="goBack()">Choose other location</app-button>
          <app-button secondary class="button-item-2" width="100%" (buttonClick)="cancel()">Don't override</app-button>
          <app-button primary class="button-item-3" width="100%" (buttonClick)="overrideNow()">Override now</app-button>
        </div>
      </div>
    }
    @case (3) {
      <div class="modal-header">
        <h4 class="modal-title">2. Stop overriding all locations</h4>
        <div class="dots">
          <span class="dot"></span>
          <span class="dot active"></span>
        </div>
      </div>
      <div class="form-group modal-body">
        @if (distributionCount() >= 0) {
          <p class="mt-2">
            This will undo the location override on all <strong>{{distributionCount()}}
            distributions</strong> and all documents will be sent to their original locations.
          </p>
        }
      </div>
      <div class="modal-footer">
        <div class="button-container">
          <app-button secondary class="button-item-2" width="100%" (buttonClick)="cancel()">Don't stop</app-button>
          <app-button primary class="button-item-3" width="100%" (buttonClick)="stopNow()">Stop now</app-button>
        </div>
      </div>
    }
  }
</div>
